module.exports = __webpack_public_path__ + "img/webnew72.e306dd88.jpg";